module.exports = __webpack_public_path__ + "static/media/instructivooc7.d2d7d874.png";